import React, { Component } from "react";
import Close from "../../../components/icons/Close";

class popup extends Component {
  render() {
    const { data, title, active, onclick } = this.props;
    return (
      <div className={`popup ${active}`}>
        <p>{title}</p>
        {data}
        <div className="button-close-popup">
          <button onClick={onclick} className="button-scroll-to-section close">
            <Close width={20} height={20} fill="#04a8a6" />
          </button>
        </div>
      </div>
    );
  }
}

export default popup;



// WEBPACK FOOTER //
// ./src/pages/PhuketSkypark/components/popup.js